import { HubSetting } from 'hs-resources/resources/HubSetting';
import { skipToken } from 'pulse/react';
import { useHttpResource } from '../../client/useHttpResource';
const DEFAULT_SAVING_MODE = 'auto';
export const useSavingMode = (options = {}) => {
  const {
    data,
    loading,
    error
  } = useHttpResource(HubSetting, {
    params: options.skip ? skipToken : {
      settingName: 'CRM:Properties:AutosaveMode'
    }
  });
  const savingMode = data === 'auto' || data === 'manual' ? data : DEFAULT_SAVING_MODE;
  return {
    data: savingMode,
    loading,
    error
  };
};